module.exports = __webpack_public_path__ + "static/media/cure.2539c358.png";